<template>
  <BaseContainer class="dnnCloud-company-box" :loading="listLoading" :isHasPageFt="!listLoading">
    <template v-slot:hd>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-form-item>
            <el-select v-model="regionCode" placeholder="大区" style="width:150px" :clearable="true">
              <el-option v-for="item in regionCodeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchText" placeholder="企业名称" style="width:200px;" clearable
              @keyup.enter.native="getList(1)"></el-input>
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <SelectCommon placeholder="客户经理" style="width: 150px" :clearable="true" apiPath="/tbAdminuser/manageList"
              :keys="{ label: 'name', value: 'id' }" :defaultVal="managerAdminuser"
              @change="(value, datas) => handleSelectCommonFilter(value, datas, 'managerAdminuser')" />
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <SelectCommon placeholder="客户成功经理" style="width: 150px" :clearable="true"  apiPath="/tbAdminuser/list"
              :params="{ type: 3 }"
              :keys="{ label: 'name', value: 'id' }" :defaultVal="successfulManager" @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'successfulManager')
              " />
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <SelectCommon placeholder="经销商" style="width: 150px" :clearable="true" apiPath="/tbAdminuser/list"
            :params="{ type: 4 }"
              :keys="{ label: 'name', value: 'id' }" :defaultVal="agencyManager" @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'agencyManager')
              " />
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="deadTime" :default-value="deadTime" type="date" placeholder="过期截止日期" format='yyyy-MM-dd' value-format='yyyy-MM-dd' style="width: 150px"></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getList(1)">查询</el-button>
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <el-button type="primary" size="medium" v-on:click="batchExport()" :loading="exportLoading">
              批量导出<span v-if="exportList.length"> ({{exportList.length}})</span>
            </el-button>
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1 || userInfo.type == 0">
            <el-button type="primary" size="medium" v-on:click="batchImport()" :loading="importLoading">批量导入</el-button>
            <input type="file" id="importProbation" style="display:none" name="file" ref="clearFileModal"
              accept=".xls,.xlsx" @change="importCompanyFile($event)" />
          </el-form-item>

        </el-form>
      </el-col>

    </template>

    <template v-slot:main>
      <div class="tips">
        <span>试用客户总数量：</span><span class="blueNumber">{{ total }}</span>
        <span>甲级试用客户数量：</span><span class="redNumber">{{ levelTotal }}</span>
        <span>试用用户数：</span><span class="purpleNumber">{{ tryTotal }}</span>
        <span>高校试用用户数：</span><span class="colleges">{{ collegesTotal }}</span>
        <span>设计院试用用户数：</span><span class="institute">{{ instituteTotal }}</span>
      </div>
      <!--列表-->
      <el-table ref="companyTable" tooltip-effect="dark" :data="proList" row-key="id" highlight-current-row @selection-change="selsChange"
        @sort-change="handleSortChange" :height="maxTbHeight - 36" style="width: 100%" :header-cell-style="getRowClass">
        <el-table-column type="selection" :reserve-selection="true" width="55">
        </el-table-column>
        <el-table-column type="index" :index="indexMethod" label="序号" width="60">
          <template slot-scope="scope">
            <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="regionCode" label="大区代号" sortable="custom" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.regionCode === '1'" class="gray">华东大区</div>
            <div v-if="scope.row.regionCode === '2'" class="gray">华北大区</div>
            <div v-if="scope.row.regionCode === '3'" class="gray">西北大区</div>
            <div v-if="scope.row.regionCode === '4'" class="gray">华南大区</div>
            <div v-if="scope.row.regionCode === '5'" class="gray">西南大区</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="企业名称" sortable="custom" min-width="250" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="grade" label="资质等级" sortable="custom" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.grade === '1'" class="blue">综合甲</div>
            <div v-if="scope.row.grade === '2'" class="blue">公路甲</div>
            <div v-if="scope.row.grade === '3'" class="blue">市政甲</div>
            <div v-if="scope.row.grade === '4'" class="blue">公路市政甲</div>
            <div v-if="scope.row.grade === '5'" class="purple">公路乙</div>
            <div v-if="scope.row.grade === '6'" class="purple">市政乙</div>
            <div v-if="scope.row.grade === '7'" class="purple">公路市政乙</div>
            <div v-if="scope.row.grade === '9'" class="purple">高校</div>
            <div v-if="scope.row.grade === '10'" class="purple">施工单位</div>
            <div v-if="scope.row.grade === '8'" class="other">其他</div>
          </template>
        </el-table-column>
        <el-table-column prop="natrue" label="企业性质" sortable="custom" min-width="100">
          <template slot-scope="scope">
            {{
              scope.row.natrue === '1' ? '央企' : scope.row.natrue === '2' ? '国企' : scope.row.natrue === '3' ? '民营上市' :
                scope.row.natrue === '4' ? '民营' : scope.row.natrue === '5' ? '高校' : '-'
            }}
          </template>
        </el-table-column>
        <el-table-column prop="syuc" label="试用用户数" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="purpleNumber">{{ scope.row.syuc ? scope.row.syuc : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="showname" label="地区" sortable="custom" min-width="140" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="公司管理员" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.managername ? scope.row.managername : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户经理" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.managerAdminuserName ? scope.row.managerAdminuserName : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户成功经理" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
              scope.row.successfulManagerName
              ? scope.row.successfulManagerName
              : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="经销商" min-width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
              scope.row.agencyManagerName
              ? scope.row.agencyManagerName
              : "-"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="正式产品总数" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="blue_num">{{ scope.row.ac ? scope.row.ac : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="即将过期产品数量" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="orange">{{ scope.row.dc ? scope.row.dc : '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" min-width="100" style="text-algin: center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="详情" placement="top" class="caozuo">
              <span class="dnnfont iconfile-search" @click="handleCom(scope.$index, scope.row)"></span>
            </el-tooltip>

            <!-- 创建人&&没有订单 -->
            <el-tooltip effect="dark" v-if="id == scope.row.createUser && scope.row.delFlg !== '0'" content="删除"
              placement="top" class="caozuo">
              <span class="dnnfont icondelete" @click="handleDel(scope.$index, scope.row)"></span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

    </template>

    <template v-slot:ft>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 50, 100]"
          :current-page.sync="pageNumber" @current-change="handleCurrentChange" @size-change="handleSizeChange"
          :page-size="pageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import { API__code, API_User, API_Urls, API_Admin, API_Common, API__Position, } from '../../../api/index.js'
import GisCommon from '@/components/GisCommon'
import BaseContainer from '@/components/BaseContainer'
import axios from 'axios'
import SelectCommon from '@/components/SelectCommon'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  data() {

    return {
      proName: '',
      dynamicTags: [],
      value: '',
      rname: '',
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      souchs: {
        name: '',
      },
      total: 0,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],
      exportList: [], // 跨页保留需要导出的多选数据
      exportLoading: false,
      needClearSel: false,
      importLoading: false,
      orderType: '',
      orderStr: '',
      userSelection: [],
      searchText: this.$route.query.searchText ? this.$route.query.searchText : '',
      address: '',
      comLists: [],
      status: this.$route.query.status ? this.$route.query.status : '',
      distributionStatus: this.$route.query.distributionStatus ? this.$route.query.distributionStatus : '',
      managerAdminuser: this.$route.query.managerAdminuserName,
      successfulManager:'',
      agencyManager:'',
      total: 0,
      levelTotal: 0,
      tryTotal: 0,
      collegesTotal:0,
      instituteTotal:0,
      regionCodeList: [
        {
          value: '1',
          label: '华东大区',
        },
        {
          value: '2',
          label: '华北大区',
        },
        {
          value: '3',
          label: '西北大区',
        },
        {
          value: '4',
          label: '华南大区',
        },
        {
          value: '5',
          label: '西南大区',
        },
      ],
      regionCode: '',
      deadTime: ''
    }
  },

  computed: {
    ...mapGetters(['userInfo']),
  },

  components: {
    BaseContainer,
    SelectCommon,
    GisCommon,
  },
  methods: {

    // 客户经理过滤
    handleSelectCommonFilter(value, datas, key) {
      this[key]=value[0]
    },

    // 批量导出
    batchExport() {
      if (!this.exportList.length) {
        this.$message.error('请先勾选要导出的企业')
        return
      }
      let param = {
        ids: this.exportList.map(item => item.id),
      }
      this.exportLoading = true
      API_User.exportCompanyExcel(param)
        .then((res) => {
          if (res.data.type && res.data.type.indexOf('json') > -1) {
            // 后端返回JSON，说明导出出错（如登录过期）
            const reader = new FileReader()
            reader.onload = () => {
              const result = JSON.parse(reader.result)
              this.$message.error(result.message || '导出失败')
            }
            reader.readAsText(res.data)
          } else {
            const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
            const fileName = '试用客户管理_' + Date.now() + '.xls'
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
            this.$message.success('导出成功')
          }
          this.exportLoading = false
        })
        .catch((err) => {
          this.$message.error('导出失败，请稍后重试！')
          this.exportLoading = false
        })
    },

    // 批量导入：触发文件选择
    batchImport() {
      this.$refs.clearFileModal.click()
    },

    // 选择文件后上传导入
    importCompanyFile(fileEvent) {
      const file = fileEvent.target.files[0]
      if (!file) {
        this.$message.error('请选择文件！')
        return
      }
      if (!/\.(xls|xlsx)$/i.test(file.name)) {
        this.$message.error('请选择xls或xlsx格式的文件！')
        this.$refs.clearFileModal.value = ''
        return
      }
      // 转义，防止Excel内容中的特殊字符破坏弹窗HTML
      const esc = function (val) {
        return String(val == null ? '' : val)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
      }
      let formData = new FormData()
      formData.append('file', file)
      this.importLoading = true
      API_User.importCompanyExcel(formData)
        .then((res) => {
          console.log('导入接口返回：', res.data) // TODO: 联调确认后可删除
          let data = res.data || {}
          // 兼容后端整体返回JSON字符串的情况
          if (typeof data === 'string') {
            try {
              data = JSON.parse(data)
            } catch (e) {}
          }
          if (data.code == API__code.SUCCESS) {
            let detail = data.data || {}
            // 兼容data为JSON字符串的情况
            if (typeof detail === 'string') {
              try {
                detail = JSON.parse(detail)
              } catch (e) {
                detail = {}
              }
            }
            // 兼容faillist/failList两种字段名
            const failList = detail.faillist || detail.failList || []
            if (failList.length > 0 || Number(detail.fail) > 0) {
              // 存在导入失败的数据，弹窗列出失败明细
              let html = '<div>' + esc(data.message) + '</div>'
              if (!failList.length) {
                html += '<div>失败数：' + esc(detail.fail) + '</div>'
              }
              failList.forEach((item) => {
                html += '<div>第' + esc(item.rowNum) + '行 ' + esc(item.companyName) + '，' + esc(item.reason) + '</div>'
              })
              this.$alert(html, '部分数据导入失败', {
                customClass: 'import-fail-alert',
                dangerouslyUseHTMLString: true,
                confirmButtonText: '知道了',
              })
            } else {
              // 全部导入成功，直接提示message
              this.$message.success(data.message || '导入成功')
            }
            this.getList(1) // 刷新列表（回到第一页并清空已选项）
          } else {
            this.$message.error(data.message || '导入失败')
          }
          this.importLoading = false
          this.$refs.clearFileModal.value = '' // 复位，保证可重复选择同一文件
        })
        .catch((err) => {
          this.$message.error('导入失败，请稍后重试！')
          this.importLoading = false
          this.$refs.clearFileModal.value = ''
        })
    },

    // 排序
    handleSortChange: function (val) {
      if (val) {
        if (val.prop == 'id') {
          this.orderStr = 'idpx'
        } else if (val.prop == 'name') {
          this.orderStr = 'namepx'
        } else if (val.prop == 'managername') {
          this.orderStr = 'managernamepx'
        } else if (val.prop == 'showname') {
          this.orderStr = 'shownamepx'
        }
        else if (val.prop == 'regionCode') {
          this.orderStr = 'regionCodepx'
        }
        else if (val.prop == 'grade') {
          this.orderStr = 'gradepx'
        }
        else if (val.prop == 'natrue') {
          this.orderStr = 'natruepx'
        }
        else if (val.prop == 'userScale') {
          this.orderStr = 'userScalepx'
        }
        if (val.order == 'descending') {
          this.orderType = 'desc'
        } else {
          this.orderType = 'asc'
        }
      }
      this.getList()
    },

    // 删除
    handleDel: function (index, row) {
      this.$confirm('确认删除吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          let para = {
            token: this.token,
            checkCode: this.checkCode,
            id: row.id,
          }
          API_User.delCompanyList(para)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({
                  message: '删除成功',
                  type: 'success',
                })
                this.getList()
              } else {
                this.$message.error(res.data.message)
                if (res.data.code == 403) {
                  this.$router.push({ path: 'loginAdmin' })
                }
              }
            })
            .catch((err) => {
              this.$message.error('数据丢失，试试重新登陆！')
            })
        })
        .catch((err) => { })
    },

    // 详情页跳转
    handleCom: function (index, row) {
      this.$router.push({
        path: '/probationView',
        query: {
          companyId: row.id,
          managerId: row.managerid,
          companyName: row.name,
          isbinding: row.isbinding,
          dynamicTags: JSON.stringify(this.dynamicTags),
          souchs: JSON.stringify(this.souchs),
          searchText: this.searchText,
          distributionStatus: this.distributionStatus,
          managerAdminuser: this.managerAdminuser,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          regionCode: this.regionCode,
          successfulManager:this.successfulManager,
          agencyManager:this.agencyManager,
          deadTime: this.deadTime,
        },
      })
    },

    // 列表查询
    getList: function (val) {
      // 仅主动查询(getList(1))时清空已选，普通翻页不清空
      this.needClearSel = val == 1
      if (this.value == 'ID') {
        this.souchs.id = this.proName
      }
      if (this.value == '企业名称') {
        this.souchs.company = this.proName
      }
      if (this.value == '管理员') {
        this.souchs.managername = this.proName
      }
      var flag = true
      if (val == 1) {
        this.pageNumber = 1
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value)
          }
        }
      }
      let param = {
        // token: this.token,
        // checkCode: this.checkCode,
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        managename: this.souchs.managename,
        id: this.souchs.id,
        company: this.souchs.company,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        successfulManager:this.successfulManager,
        agencyManager:this.agencyManager,
        searchText: this.searchText,
        status: 2,
        regionCode: this.regionCode,
        deadTime: this.deadTime
      }
      this.listLoading = true
      API_User.companyList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            if (res.data) {
              this.total = res.data.data.totalRow
              this.levelTotal = res.data.c2
              this.tryTotal = res.data.c3
              this.collegesTotal=res.data.c4
              this.instituteTotal=res.data.c5
              this.proList = res.data.data.list
              if (this.needClearSel && this.$refs.companyTable) {
                // 重新查询后清空跨页保留的选中项（触发 selection-change，exportList 自动置空）
                this.$refs.companyTable.clearSelection()
              }
            }
          } else {
            this.$message.error(res.data.message)
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' })
            }
          }
          this.listLoading = false
        })
        .catch((err) => {
          this.$message.error('数据丢失，试试重新登陆！')
          this.listLoading = false
        })
    },

    // 索引
    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize
    },

    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return 'background:#F5F7FA'
      } else {
        return ''
      }
    },

    selsChange: function (sels) {
      this.sels = sels
      this.exportList = sels
    },

    // 每页列表数据条数切换
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },

    // 分页切换
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getList()
    },

    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1] //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1]
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1]
          }
        }
      }
    },

    initDate() {
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;   //格式化月份，补0
      let statDateStart = myDate.getFullYear().toString() + month + "01"; //月初
      let dayEnd = new Date(myDate.getFullYear(), month, 0).getDate(); //获取当月一共有多少天
      let statDateEnd = myDate.getFullYear().toString() + '-' + month + '-' + dayEnd; //月末
      console.log(statDateStart);   //20230101
      console.log('statDateEnd--',statDateEnd);     //20230131
      this.deadTime = statDateEnd
    },
    // 初始化搜索信息
    initSearchParams() {
      let { regionCode, searchText,managerAdminuser,successfulManager,agencyManager,distributionStatus,gradeValue,deadTime } = this.$route.query;
      this.regionCode= regionCode || ''
      this.searchText= searchText || ''
      this.managerAdminuser= managerAdminuser || ''
      this.successfulManager= successfulManager || ''
      this.agencyManager= agencyManager || ''
      if(deadTime) {
        this.deadTime= deadTime
      }
    },

  },
  mounted() {
    console.log(this.$route.query.distributionStatus)
  },
  created() {
    this.getCookie()
    this.initSearchParams()
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags)
      this.souchs = JSON.parse(this.$route.query.souchs)
      this.pageNumber = JSON.parse(this.$route.query.pageNumber)
    }
    this.initDate()
    this.getList()

  },
}
</script>

<style lang="scss">
.dnnCloud-company-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  .avatar-uploader-icon {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  .avatar {
    width: 120px;
    height: 120px;
  }
}

// 导入失败明细弹窗：内容区固定高度500px，超出部分纵向滚动
.import-fail-alert {
  .el-message-box__content {
    max-height: 500px;
    overflow-y: auto;
  }
}
</style>
<style  lang="scss" scoped>
.el-select {
  display: inline-block;
  position: relative;
  width: 115px;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.map {
  width: 100%;
  height: 750px;
}

.caozuo {
  cursor: pointer;
  margin-right: 12px;
}

.tips {
  font-size: 14px;
  line-height: 22px;
  color: #666666;
  margin-bottom: 14px;

  .blueNumber {
    color: #669df0;
    margin-right: 32px;
  }

  .redNumber {
    color: #eb6264;
    margin-right: 32px;
  }

  .purpleNumber {
    color: #BE74D9;
    margin-right: 32px;
  }
  .colleges{
    color: #7FDDA5;
    margin-right: 32px;
  }
  .institute{
    color: #FFAB7D;
  }
}

.purpleNumber {
  color: #BE74D9;
}

.blue {
  min-width: 60px;
  max-width: 94px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  background: #F1F5FF;
  color: #669DF0;
  border-radius: 2px;
}

.purple {
  min-width: 60px;
  max-width: 94px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  background: #F8F1FB;
  color: #BE74D9;
  border-radius: 2px;
}

.other {
  min-width: 60px;
  max-width: 94px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  color: #666666;
  border-radius: 2px;
  background: #F7F7F7;
}

.gray {
  // width: 60px;
  width: 80px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #d3d4d6;
  color: #909399;
  border-radius: 2px;

}
</style>



// WEBPACK FOOTER //
// probationCustom.vue?11acc87a